import { TApplicationState } from '../../types/redux';
import { INewbuildingLayout } from '../../types/layouts/layout';

export const selectLayoutById =
  (id: number) =>
  (state: TApplicationState): INewbuildingLayout => {
    return state.catalog.layoutsById[id];
  };
